import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPsico'; 
import AboutPsicopedagogia from './AboutPsicoSistemica';
import Psicopedagogia from './CorpoClinicoPsicoSistemica';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutPsicopedagogia />
        <Psicopedagogia />
      </div>
    );
  };
  
  export default About;
  